import { ref, type Ref } from 'vue'

export interface Toast {
  id: number
  title?: string
  message: string
  type: 'success' | 'error'
}

const TOAST_DURATION = 4000
const MAX_TOASTS = 3

let nextId = 0
const toasts: Ref<Toast[]> = ref([])

export function dismiss(id: number) {
  toasts.value = toasts.value.filter((t) => t.id !== id)
}

function addToast(message: string, type: 'success' | 'error', title?: string) {
  const id = ++nextId
  toasts.value.push({ id, title, message, type })

  if (toasts.value.length > MAX_TOASTS) {
    toasts.value = toasts.value.slice(-MAX_TOASTS)
  }

  setTimeout(() => dismiss(id), TOAST_DURATION)
}

export function showSuccess(message: string, title?: string) {
  addToast(message, 'success', title)
}

export function showError(message: string, title?: string) {
  addToast(message, 'error', title)
}

export function useToast() {
  return {
    toasts: toasts as Readonly<Ref<Toast[]>>,
    showSuccess,
    showError,
    dismiss,
  }
}
